import { useEffect, useState } from 'react'
import JurisprudenceProviders from '@services/jurisprudenceProviders'
import { validateResearchFile } from './legalResearchHelpers'

export default function ResearchAssistedImport({ research, issues, disabled }) {
  const [providers, setProviders] = useState([])
  const [fields, setFields] = useState({ providerId: '', nativeId: '', court: '', kind: 'MainDecision', title: '', processNumber: '' })
  const [issueIds, setIssueIds] = useState([])
  const [file, setFile] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const [revision, setRevision] = useState(0)
  useEffect(() => {
    const controller = new AbortController()
    setLoading(true)
    JurisprudenceProviders.list(controller.signal).then((response) => {
      if (controller.signal.aborted) return
      if (response.success && Array.isArray(response.data)) { setProviders(response.data.filter((provider) => provider.enabled)); setError('') }
      else setError('Não foi possível consultar as fontes habilitadas para importação. Tente recarregar.')
      setLoading(false)
    }).catch(() => { if (!controller.signal.aborted) { setError('Não foi possível consultar as fontes habilitadas.'); setLoading(false) } })
    return () => controller.abort()
  }, [revision])
  const provider = providers.find((value) => value.providerId === fields.providerId)
  const change = (key, value) => setFields((previous) => ({ ...previous, [key]: value,
    ...(key === 'providerId' ? { court: '' } : {}) }))
  const submit = async (event) => {
    event.preventDefault()
    const failure = validateResearchFile(file)
    if (failure) { setError(failure); return }
    if (!provider || !fields.nativeId.trim() || !fields.court.trim() || issueIds.length < 1 || issueIds.length > 8) return
    setError('')
    await research.importCandidate({ providerId: fields.providerId, nativeId: fields.nativeId.trim(), court: fields.court.trim().toUpperCase(),
      kind: fields.kind, ...(fields.title.trim() ? { title: fields.title.trim() } : {}),
      ...(fields.processNumber.trim() ? { processNumber: fields.processNumber.trim() } : {}) }, file, issueIds)
  }
  return <details className="legal-research-official-link">
    <summary>Importar julgado consultado manualmente</summary>
    <p className="acervo-muted">Para fontes sem busca automática, informe a identidade do documento e envie o original. A origem, o texto e a pertinência precisarão de conferência; a importação não autoriza a citação.</p>
    {loading && <p role="status">Carregando fontes…</p>}
    {error && <p className="acervo-error" role="alert">{error}</p>}
    <button className="acervo-button" type="button" disabled={disabled || loading} onClick={() => setRevision((value) => value + 1)}>Recarregar fontes</button>
    <form onSubmit={submit}>
      <fieldset disabled={disabled || loading}>
        <legend>Identidade do documento original</legend>
        <label className="acervo-field">Fonte
          <select value={fields.providerId} onChange={(event) => change('providerId', event.target.value)} required>
            <option value="">Selecione a fonte habilitada</option>
            {providers.map((value) => <option key={value.providerId} value={value.providerId}>{value.name}</option>)}
          </select>
        </label>
        <label className="acervo-field">Tribunal
          {provider?.courts?.length > 0 ? <select value={fields.court} required onChange={(event) => change('court', event.target.value)}>
            <option value="">Selecione o tribunal</option>
            {provider.courts.map((court) => <option value={court} key={court}>{court}</option>)}
          </select> : <input value={fields.court} maxLength={20} required onChange={(event) => change('court', event.target.value)} />}
        </label>
        <label className="acervo-field">Identificador do julgado na fonte
          <input value={fields.nativeId} maxLength={160} required onChange={(event) => change('nativeId', event.target.value)} />
        </label>
        <label className="acervo-field">Tipo de documento
          <select value={fields.kind} onChange={(event) => change('kind', event.target.value)}>
            <option value="MainDecision">Decisão / acórdão principal</option>
            <option value="IntegrativeDecision">Decisão integrativa / embargos</option>
            <option value="Decision">Outra decisão</option>
            <option value="Summary">Ementa</option>
            <option value="Theme">Tema</option>
          </select>
        </label>
        <label className="acervo-field">Título (opcional)<input value={fields.title} maxLength={500} onChange={(event) => change('title', event.target.value)} /></label>
        <label className="acervo-field">Número do processo (opcional)<input value={fields.processNumber} maxLength={100} onChange={(event) => change('processNumber', event.target.value)} /></label>
        <label className="acervo-field">Original em PDF, DOCX ou TXT, até 2 MB
          <input type="file" accept=".pdf,.docx,.txt" required onChange={(event) => setFile(event.target.files?.[0] || null)} />
        </label>
        <p>Questões às quais o documento será associado</p>
        {issues.map((issue) => <label key={issue.issueId} className="legal-research-issue-choice">
          <input type="checkbox" checked={issueIds.includes(issue.issueId)} onChange={(event) => setIssueIds((previous) => event.target.checked
            ? [...previous, issue.issueId] : previous.filter((id) => id !== issue.issueId))} /> {issue.question}
        </label>)}
        <button type="submit" className="acervo-button" disabled={!provider || !file || !fields.nativeId.trim() || !fields.court.trim() || issueIds.length < 1 || issueIds.length > 8}>Importar e revalidar</button>
      </fieldset>
    </form>
  </details>
}
